export const importRavelin = async () => {
  const { default: Ravelin } = await import('ravelinjs/core+track+encrypt');

  return Ravelin;
};
